<template>
  <section>
    <el-form :inline="true" class="toolbar" :model="searchForm">
      <el-form-item label="日期">
        <el-date-picker
          v-model="searchForm.searchDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      border
      height="650"
      style="width: 100%"
      v-loading="loading">
      <el-table-column
        align="center"
        prop="merchantName"
        label="商户"></el-table-column>
      <el-table-column
        align="center"
        prop="tradeDate"
        label="日期"></el-table-column>
      <el-table-column
        align="center"
        prop="inCnt"
        label="代收单数"></el-table-column>
      <el-table-column
        align="center"
        prop="inAmount"
        label="代收金额"></el-table-column>
      <el-table-column
        align="center"
        prop="inMerchantFee"
        label="代收费用"></el-table-column>

      <el-table-column
        align="center"
        prop="outSuccessCnt"
        label="代付单数(成功)"></el-table-column>
      <el-table-column
        align="center"
        prop="outSuccessAmount"
        label="代付金额(成功)"></el-table-column>
      <el-table-column
        align="center"
        prop="outSuccessMerchantFee"
        label="代付费用(成功)"></el-table-column>

      <el-table-column
        align="center"
        prop="outPendingCnt"
        label="代付中单数"></el-table-column>
      <el-table-column
        align="center"
        prop="outPendingAmount"
        label="代付中金额"></el-table-column>
      <el-table-column
        align="center"
        prop="outPendingMerchantFee"
        label="代付中费用"></el-table-column>
    </el-table>
  </section>
</template>

<script>
import api from "../../api/report/index";

export default {
  mixins: [],
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        searchDate: this.getCurrentDate()
      },
      merchantList: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  methods: {
    search() {
      this.getList();
    },
    async getList() {
      this.loading = true;
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      _data.content = content;
      let res = await api.getMerchantDataListApi(_data);
      if (res.code == "0000") {
        this.loading = false;
        this.tableData = res.data;
      }else {
        this.$message.error(res.message);
      }
    },
    // 获取当前日期（yyyy-MM-dd）
    getCurrentDate() {
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0]; // 格式: yyyy-MM-dd
      return [todayStr, todayStr]; // 开始和结束都是当天
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped>
:deep(.table_header) {
  color: blue;

  cursor: pointer;
}
:deep(.table_header .cell) {
  text-decoration: underline;
}
</style>
